<template>
  <el-container style="height: 100%">
    <div class="frameTabs" style="display: flex; width: 100%; height: 100%">
      <el-header style="
          background-color: #01204e;
          height: 100%;
          width: 210px;
          border-right: 1px solid #024366;
          overflow-x: hidden;
        " class="test-1">
        <div class="logo">
          <img :src="logo" />
        </div>
        <div class="navTab">
          <el-menu class="el-menu-demo" mode="vertical" :collapse="false" background-color="#01204E"
            :default-active="$route.path" :text-color="header_text_color" :active-text-color="header_active_text_color"
            :unique-opened="false">
            <template v-for="(menu, mindex) in menuList">
              <template v-if="menu.children !== undefined && menu.children.length > 0">
                <el-submenu :index="mindex + ''">
                  <template slot="title">{{
                    menuLangList[menu.menu_id]
                      ? menuLangList[menu.menu_id]
                      : menu.menu_name
                  }}</template>
                  <template v-for="(smenu, smindex) in menu.children">
                    <template v-if="
                      smenu.children !== undefined &&
                      smenu.children.length > 0
                    ">
                      <el-submenu :index="mindex + '-' + smindex">
                        <template slot="title">{{
                          menuLangList[smenu.menu_id]
                            ? menuLangList[smenu.menu_id]
                            : smenu.menu_name
                        }}</template>
                        <template v-for="(sumenu, suindex) in smenu.children">
                          <template v-if="sumenu.menu_type == 0">
                            <router-link :to="sumenu.menu_url" @click.native="
                              $routerTab.refresh(sumenu.menu_url)
                              " exact><el-menu-item :index="sumenu.menu_url">{{
                                sumenu.menu_name
                              }}</el-menu-item></router-link>
                          </template>
                          <template v-else>
                            <a :href="sumenu.menu_url" target="_blank"><el-menu-item :index="sumenu.menu_url">{{
                              sumenu.menu_name
                                }}</el-menu-item></a>
                          </template>
                        </template>
                      </el-submenu>
                    </template>
                    <template v-else>
                      <template v-if="smenu.menu_type == 0">
                        <router-link :to="smenu.menu_url" @click.native="$routerTab.refresh(smenu.menu_url)" exact>
                          <el-menu-item :index="smenu.menu_url">{{
                            menuLangList[smenu.menu_id]
                              ? menuLangList[smenu.menu_id]
                              : smenu.menu_name
                          }}</el-menu-item>
                        </router-link>
                      </template>
                      <template v-else>
                        <a :href="smenu.menu_url" target="_blank"><el-menu-item :index="smenu.menu_url">{{
                          menuLangList[smenu.menu_id]
                            ? menuLangList[smenu.menu_id]
                            : smenu.menu_name
                            }}</el-menu-item></a>
                      </template>
                    </template>
                  </template>
                </el-submenu>
              </template>
              <template v-else>
                <template v-if="menu.menu_type == 0">
                  <router-link :to="menu.menu_url" @click.native="$routerTab.refresh(menu.menu_url)" exact>
                    <el-menu-item :index="menu.menu_url">{{
                      menuLangList[menu.menu_id]
                        ? menuLangList[menu.menu_id]
                        : menu.menu_name
                    }}</el-menu-item>
                  </router-link>
                </template>
                <template v-else>
                  <a :href="menu.menu_url" target="_blank"><el-menu-item :index="menu.menu_url">{{
                    menuLangList[menu.menu_id]
                      ? menuLangList[menu.menu_id]
                      : menu.menu_name
                      }}</el-menu-item></a>
                </template>
              </template>
            </template>
          </el-menu>
        </div>
        <el-dialog title="用户信息" :visible.sync="dialogUserInfoFormVisible">
          <el-form :model="user">
            <el-form-item label="用户名" label-width="120px">
              <span>{{ user.username }}</span>
            </el-form-item>
            <el-form-item label="公司名称" label-width="120px">
              <span>{{ user.corporate_name }}</span>
            </el-form-item>
            <el-form-item label="公司地址" label-width="120px">
              <span>{{ user.corporate_address }}</span>
            </el-form-item>
            <el-form-item label="联系电话" label-width="120px">
              <span>{{ user.contact_number }}</span>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogUserInfoFormVisible = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="GLOBAL.langList.ChangePassword
          ? GLOBAL.langList.ChangePassword
          : '密码修改'
          " :visible.sync="dialogPasswordFormVisible">
          <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="160px">
            <el-form-item :label="GLOBAL.langList.OldPassword
              ? GLOBAL.langList.OldPassword
              : '旧密码'
              " prop="oldPassword">
              <el-input type="password" v-model="passwordForm.oldPassword" style="width: 300px" :placeholder="GLOBAL.langList.EnterOldPassword
                ? GLOBAL.langList.EnterOldPassword
                : '请输入旧密码'
                "></el-input>
            </el-form-item>
            <el-form-item :label="GLOBAL.langList.NewPassword
              ? GLOBAL.langList.NewPassword
              : '新密码'
              " prop="password">
              <el-input type="password" v-model="passwordForm.password" style="width: 300px" :placeholder="GLOBAL.langList.EnterNewPassword
                ? GLOBAL.langList.EnterNewPassword
                : '请输入新密码'
                "></el-input>
            </el-form-item>
            <el-form-item :label="GLOBAL.langList.ConfirmNewPassword
              ? GLOBAL.langList.ConfirmNewPassword
              : '确认新密码'
              " prop="rePassword">
              <el-input type="password" v-model="passwordForm.rePassword" style="width: 300px" :placeholder="GLOBAL.langList.ReEnterNewPassword
                ? GLOBAL.langList.ReEnterNewPassword
                : '请再次输入新密码'
                "></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onPassSubmit('passwordForm')">{{
              GLOBAL.langList.OK ? GLOBAL.langList.OK : "确 定"
            }}</el-button>
          </span>
        </el-dialog>
      </el-header>
      <el-main>
        <div class="el_box_main">
          <div class="el_header_right">
            <div class="header-right">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link" :style="{ cursor: 'pointer', color: header_text_color }">
                  <img :src="GLOBAL.user.avatar" class="userImg"
                    :style="{ border: '1px solid ' + header_text_color }" />{{
                      GLOBAL.user.username }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!--<el-dropdown-item v-if="user.type==1" command="userInfo">用户信息</el-dropdown-item>-->
                  <el-dropdown-item command="editPassword">{{
                    GLOBAL.langList.ChangePassword
                      ? GLOBAL.langList.ChangePassword
                      : "密码修改"
                  }}</el-dropdown-item>
                  <el-dropdown-item command="logout" divided>{{
                    GLOBAL.langList.Logout ? GLOBAL.langList.Logout : "用户注销"
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <router-tab :tabs="tabs" />
        </div>
      </el-main>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "Frame",
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error((this.GLOBAL.langList.ReEnterNewPassword) ? this.GLOBAL.langList.ReEnterNewPassword : '请再次输入新密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error((this.GLOBAL.langList.EnterTowPasswordError) ? this.GLOBAL.langList.EnterTowPasswordError : '两次输入新密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      logo: this.GLOBAL.logo,
      header_background_color: '#1F2D3D',
      header_text_color: '#FFFFFF',
      header_active_text_color: '#409EFF',
      menuList: [],
      menuLangList: [],
      tabs: [
        { to: '/index', closable: false },
      ],
      user: this.GLOBAL.user,
      dialogUserInfoFormVisible: false,
      dialogPasswordFormVisible: false,
      passwordForm: {
        id: this.GLOBAL.user.id,
        oldPassword: '',
        password: '',
        rePassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: (this.GLOBAL.langList.EnterOldPassword) ? this.GLOBAL.langList.EnterOldPassword : '请输入旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: (this.GLOBAL.langList.EnterNewPassword) ? this.GLOBAL.langList.EnterNewPassword : '请输入新密码', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
    }
  },
  created: function () { //钩子函数
    this.GLOBAL.lang = Number(sessionStorage.getItem('lang'))
    if (this.GLOBAL.lang == 0) {
      this.GLOBAL.lang = 1
    }
    this.getMenuLangList()
    this.getMenuList()
    this.config()
  },
  mounted () {
    setTimeout(() => {

    }, 2000)
  },
  methods: {
    getMenuList: function () {
      this.axios.get(this.api.ApiUrl.usermenulist + '?lang=' + this.GLOBAL.lang, {
        headers: {
          'Authorization': 'Bearer ' + this.GLOBAL.token
        }
      }).then((result) => {
        var menuData = result.data
        if (menuData.code == 20000) {
          this.menuList = menuData.data.menu_list
          this.GLOBAL.menuList = this.menuList
          console.log(6666, this.GLOBAL.menuList)
        } else if (menuData.code == 50008) {
          this.$message({
            type: 'success',
            message: (this.GLOBAL.langList.NetworkTimeout) ? this.GLOBAL.langList.NetworkTimeout : '网络超时，请重新登录'
          })
          this.$router.push({ path: '/login' })
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    getMenuLangList: function () {
      this.axios.get(this.api.ApiUrl.lang + '?lang=' + this.GLOBAL.lang + '&type=2').then((result) => {
        let menuLangData = result.data
        if (menuLangData.code == 20000) {
          this.menuLangList = menuLangData.data
        } else {
          this.menuLangList = []
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    config: function () {
      this.axios.get(this.api.ApiUrl.config).then((result) => {
        var configData = result.data
        if (configData.code == 20000) {
          this.GLOBAL.companyUrl = configData.data.url
          this.GLOBAL.logo = configData.data.logo
          this.GLOBAL.company = configData.data.company
          this.GLOBAL.companyEn = configData.data.companyEn
          this.GLOBAL.copyright = configData.data.copyright
          this.GLOBAL.contactTel = configData.data.contactTel
          this.GLOBAL.contactAddress = configData.data.contactAddress
          this.GLOBAL.contactEmail = configData.data.contactEmail
          this.logo = this.GLOBAL.logo
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    handleCommand (command) {
      if (command == 'userInfo') {
        this.dialogUserInfoFormVisible = true
      } else if (command == 'editPassword') {
        this.passwordForm = {
          id: this.GLOBAL.user.id,
          oldPassword: '',
          password: '',
          rePassword: ''
        }
        this.dialogPasswordFormVisible = true
      } else {
        this.GLOBAL.token = ''
        this.GLOBAL.user = []
        this.GLOBAL.token_expires_in = ''
        this.$cookies.set('token', this.GLOBAL.token)
        sessionStorage.setItem('token', this.GLOBAL.token)
        this.$cookies.set('user', JSON.stringify(this.GLOBAL.user))
        sessionStorage.setItem('user', JSON.stringify(this.GLOBAL.user))
        this.$cookies.set('token_expires_in', JSON.stringify(this.GLOBAL.token_expires_in))
        sessionStorage.setItem('token_expires_in', JSON.stringify(this.GLOBAL.token_expires_in))
        this.$message((this.GLOBAL.langList.LogoutSuccess) ? this.GLOBAL.langList.LogoutSuccess : '退出成功！')
        if (this.GLOBAL.ws && this.GLOBAL.ws.readyState == 1) {
          this.GLOBAL.ws.send('{"Type":1200,"user_id":' + this.GLOBAL.user.id + ',"txnNo":' + Date.parse(new Date()) + '}')
        }
        this.$router.push({ path: '/login' })
      }

    },
    onPassSubmit: function (formName) {
      console.log(formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post(this.api.ApiUrl.userrepassword, this.passwordForm, {
            headers: {
              'Authorization': 'Bearer ' + this.GLOBAL.token
            }
          }).then((result) => {
            var userPasswordPostData = result.data
            if (userPasswordPostData.code == 20000) {
              this.dialogPasswordFormVisible = false
              this.$message({
                message: (this.GLOBAL.langList.ChangePassword) ? this.GLOBAL.langList.ChangePassword : '密码修改' + (this.GLOBAL.langList.Success) ? this.GLOBAL.langList.Success : '成功',
                type: 'success'
              })
            } else if (userPasswordPostData.code == 50008) {
              this.$message({
                type: 'success',
                message: (this.GLOBAL.langList.NetworkTimeout) ? this.GLOBAL.langList.NetworkTimeout : '网络超时，请重新登录'
              })
              this.$router.push({ path: '/login' })
            } else {
              this.$message.error((this.GLOBAL.langList.ChangePassword) ? this.GLOBAL.langList.ChangePassword : '密码修改' + (this.GLOBAL.langList.Fail) ? this.GLOBAL.langList.Fail : 'Fail')
            }
          })
        } else {
          console.log(error)
          this.errored = true
          return false
        }
      })
    },
  }
}
</script>

<style>
.el-menu {
  border-right: 0;
}
</style>
<style scoped lang="scss">
/*修改滚动条样式*/
.test-1::-webkit-scrollbar {
  width: 4px;
}

.test-1::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.test-1::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #3f4f74;
}

.test-1::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background: transpent;
}

.el_box_main {
  height: 100%;

  .el_header_right {
    height: 60px;
    background-color: #01204e;

    .header-right {
      float: right;
      height: 60px;
      line-height: 60px;
    }

    .header-right .el-dropdown {
      margin-right: 30px;
      color: #f4f4f4;
    }

    .header-right .userImg {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-right: 10px;
      border-radius: 50%;
    }
  }
}

.el_header {
  width: 210px !important;
  /* background-color: #304156; */
  height: 100%;
}

.el-header {
  padding: 0;
}

div {
  display: block;
}

.el-header .logo {
  width: 10rem;
  height: 60px;
  line-height: 60px;
  float: left;
  text-align: center;
}

.el-submenu__title {
  padding: 0 10px;
}

.logo img {
  width: 8rem;
  vertical-align: middle;
}

.el-header .navTab {
  float: left;
  /* padding: 0 20px; */
  width: 100%;
  box-sizing: border-box;
}

.el-header .header-right {
  float: right;
  height: 60px;
  line-height: 60px;
}

.header-right .el-dropdown {
  margin-right: 30px;
  color: #f4f4f4;
}

.header-right .userImg {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 10px;
  border-radius: 50%;
}

.el-main {
  padding: 0;
}

.router-tab-header {
  background-color: #f2f2f2;
  border-bottom: 2px solid #e4e4e4;
}

.router-link-active {
  text-decoration: none;
}

a {
  text-decoration: none;
}
</style>
<style lang="scss">
.frameTabs {
  .el-submenu .el-menu-item {
    background-color: #021633 !important;

    &:hover {
      background-color: rgba(24, 144, 255, 0.01) !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Frame.vue